// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"so_a bhe_a bhe_r bhe_j","Photos__img":"so_b bhe_b"};